import { useContext } from 'react';

import { AuthContext } from './AuthContextValue';
import type { AuthState } from './AuthContextValue';

/**
 * Kept out of AuthContext.tsx on purpose: a module that exports both a component
 * and a plain function loses Vite's fast refresh for the whole file.
 */
export function useAuth(): AuthState {
  const context = useContext(AuthContext);

  if (context === null) {
    throw new Error('useAuth must be used inside AuthProvider');
  }

  return context;
}
